'use client';
var classes = {"month":"m_cc9820d3","monthCell":"m_8f457cd5","weekNumber":"m_6cff9dea"};

export { classes as default };
//# sourceMappingURL=Month.module.css.mjs.map
